import React from 'react'
import "../../App.css"
function Heading() {
    return (
        <div >   
       <h1 className='home-heading-1'>IETE RECRUITMENT</h1>
       <h1 className='home-heading-2'> PORTAL  </h1>
        </div>
    )
}

export default Heading
